import insertValue from './insert-value';

const PLACEHOLDER = '[PRIZE_POOL]';

const insertPrizePoolValue = (text: string | undefined, value: string) => insertValue(text, value, PLACEHOLDER);

export default insertPrizePoolValue;
